import { __assign, __read, __spread } from "tslib";
export var setColumnsOrder = function (order, data) {
    var dataKeys = Object.keys(data[0]);
    var filteredOrder = order.filter(function (o) { return dataKeys.includes(o); });
    var columnsOrder = __spread(new Set(__spread(filteredOrder, dataKeys)));
    return data.map(function (item) {
        return columnsOrder.reduce(function (acc, key) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[key] = item[key], _a)));
        }, {});
    });
};
